import { createAjaxAction } from '../../Common/_actions/AjaxAction';
import { createAction } from '../../Common/_actions/Action';

export type SignupStatus = "signup" | "success" | "mail" | "confirm" | "validation" | "exists";
export type CartStatus = "cart" | "checkout" | "paid";
export type PasswordStatus = "forgot" | "forgot-sent" | "reset" | "reset-done" | "invalid-token";

export enum UIDataActionType {
	Toast				= "UI_TOAST",
	ConsumeToast		= "UI_TOAST_CONSUME",
	EditCountries		= "UI_EDIT_COUNTRIES",
	EditLoader			= "UI_EDIT_LOADER",
	EditSignupStatus	= "UI_EDIT_SIGNUPSTATUS",
	EditPasswordStatus	= "UI_EDIT_PASSWORDSTATUS",
	EditCartStatus		= "UI_EDIT_CARTSTATUS",
	EditFabrics			= "UI_EDIT_FABRICS",
	SetOrderingStatus	= "UI_ORDER_STATUS",
	OrderProduct		= "UI_ORDER_PRODUCT",
}

export const Toast = (message: string) => createAction(UIDataActionType.Toast, {
	message: message
});

export const ConsumeToast = () => createAction(UIDataActionType.ConsumeToast);

export const EditLoader = (loader: string, value: boolean) => createAction(UIDataActionType.EditLoader, {
	loader: loader,
	value: value
});

export const EditCountries = (countries: object) => createAction(UIDataActionType.EditCountries, {
	countries: countries
});

export const GetCountries = () => createAjaxAction({
	url: "/static/data/countries.json",
	method: "GET",
	raw: true,
	preventDuplicates: true,
	onSuccess: (response, dispatch) => {
		dispatch(EditCountries(response));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
		throw "Could not retrieve country list.";
	}
});

export const EditFabrics = (fabrics: object) => createAction(UIDataActionType.EditFabrics, {
	fabrics: fabrics
});

export const GetFabrics = () => createAjaxAction({
	url: "ajax/info/get-fabrics",
	method: "GET",
	preventDuplicates: true,
	onSuccess: (response, dispatch) => {
		if(response.data.fabrics) {
			dispatch(EditFabrics(response.data.fabrics));
		}
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
		throw "Could not retrieve fabric list.";
	}
});

export const EditSignupStatus = (status: SignupStatus) => createAction(UIDataActionType.EditSignupStatus, {
	status: status
});

export const EditCartStatus = (status: CartStatus) => createAction(UIDataActionType.EditCartStatus, {
	status: status
});

export const EditPasswordStatus = (status: PasswordStatus) => createAction(UIDataActionType.EditPasswordStatus, {
	status: status
});

export const SetOrderingStatus = (status: boolean) => createAction(UIDataActionType.SetOrderingStatus, {
	status: status
});

export const OrderProduct = (id: string, productType: string) => createAction(UIDataActionType.OrderProduct, {
	id: id,
	productType: productType
});

export type UIDataAction = 
	ReturnType<typeof Toast>				|
	ReturnType<typeof ConsumeToast>			|
	ReturnType<typeof EditCountries>		|
	ReturnType<typeof EditFabrics>			|
	ReturnType<typeof EditLoader>			|
	ReturnType<typeof EditSignupStatus>		|
	ReturnType<typeof EditPasswordStatus>	|
	ReturnType<typeof EditCartStatus>		|
	ReturnType<typeof SetOrderingStatus>	|
	ReturnType<typeof OrderProduct>